
namespace GeniuzPOS.PosShift {
    import fld = PsQueueRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PsQueueGrid extends Serenity.EntityGrid<PsQueueRow, any> {
        protected getColumnsKey() { return PsQueueColumns.columnsKey; }
        protected getDialogType() { return PsQueueDialog; }
        protected getIdProperty() { return PsQueueRow.idProperty; }
        protected getInsertPermission() { return PsQueueRow.insertPermission; }
        protected getLocalTextPrefix() { return PsQueueRow.localTextPrefix; }
        protected getService() { return PsQueueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsQueueService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.TodayDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            return filters;
        }
    }
}